import React, {useCallback} from 'react';

import {useStore} from 'effector-react';
import i18next from 'i18next';
import {useTranslation} from 'react-i18next';

import {validateCode} from 'api';
import {BackTo} from 'components/common/BackTo';
import {Stepper} from 'components/ui-kit/Stepper';
import {DocumentTypeEntity} from 'core/dictionaries';
import {ROUTE} from 'core/routes';
import {
    createMovingDocument,
    data$,
    DocumentsCreateGate,
    movingForm$,
    step$,
} from 'models/documents/create';

import {CodeRequestType, CodeResponseType} from 'types/validation';

import {ProductCodes} from '../common/products';
import {ContentWrapper} from '../common/styled';

import {DocumentForm} from './form';

export const CreateMoving = () => {
    const {t} = useTranslation();
    const step = useStore(step$);
    const codes = useStore(data$);
    const movingForm = useStore(movingForm$);

    const validation = useCallback(
        async (markingCode: string, data: CodeResponseType['info'][]) => {
            const errors: string[] = [];
            const warnings: string[] = [];

            try {
                const payload: CodeRequestType = {
                    type: DocumentTypeEntity.MOVING,
                    markingCode,
                    scannedCodes: codes.map((c) => c.identityCode),
                    ...(movingForm.storageLocationFromId && {
                        storageLocationId: movingForm.storageLocationFromId,
                    }),
                };
                const codeData = (await validateCode(payload)).data;
                const pool = codeData.isValid ? warnings : errors;
                pool.push(...codeData.errors.map((e) => e.message));

                if (data.find((d) => d.identityCode === codeData.info.identityCode))
                    errors.push(i18next.t('components.scan.errors.double'));

                return {errors, warnings, codeData: codeData.info};
            } catch (e) {
                console.error(e);
                errors.push('Invalid code');
                return {errors, codeData: null};
            }
        },
        [codes, movingForm],
    );

    return (
        <>
            <BackTo to={ROUTE.DOCUMENTS_DOCUMENTS}>{t('pages.documents.back')}</BackTo>
            <ContentWrapper>
                <h1>{t('pages.documents.newDocumentMoving')}</h1>
                <DocumentsCreateGate />
                <Stepper
                    steps={[
                        {
                            label: t('pages.documents.stepOne'),
                            component: <DocumentForm />,
                        },
                        {
                            label: t('pages.documents.stepTwo'),
                            component: (
                                <ProductCodes
                                    createDocument={createMovingDocument}
                                    validation={validation}
                                />
                            ),
                        },
                    ]}
                    activeStep={step}
                />
            </ContentWrapper>
        </>
    );
};
